const TStrings = {
    ITEM_NAME_PLURAL_DESCRIPTOR: 'event types',
};

export default TStrings;
